import { render } from "./VenueSelectFieldNotary.vue?vue&type=template&id=86074ca6"
import script from "./VenueSelectFieldNotary.vue?vue&type=script&lang=js"
export * from "./VenueSelectFieldNotary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/VenueSelectFieldNotary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86074ca6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86074ca6', __exports__)) {
    api.reload('86074ca6', __exports__)
  }
  
  module.hot.accept("./VenueSelectFieldNotary.vue?vue&type=template&id=86074ca6", () => {
    api.rerender('86074ca6', render)
  })

}


export default __exports__